// NATIVE
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED
import { useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import Cropper from 'react-easy-crop';

import { PreviewPdfButton } from 'components/PreviewPdfButton';
import { Area } from 'react-easy-crop';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  Paper,
  Box,
  Typography,
  Slider,
} from '@mui/material';

// CUSTOM
import { SnackAlert } from 'components/SnackAlert';
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import TextAreaField from 'components/formFields/TextAreaField';
import CheckboxField from 'components/formFields/checkBoxField';
import { IDatosBasicos } from 'commons/interfaces';
import DatePickerField from 'components/formFields/datePickerField';
import AutocompleteField from 'components/formFields/autocompleteField';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { formatPhoneNumber, formatShortPhoneNumber } from 'commons/utils';
import { uploadPdfStore } from 'store/uploaders';
import { storeVerifyEmail, storeDetailEmployee } from 'store/employee/thunks';

export const InformacionBasica = (props: any) => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // USE FORMIK CONTEXT
  const formikProps: any = useFormikContext();

  // REDUX
  const navigate = useNavigate();
  const { countries_list, sites_list }: IDatosBasicos = useSelector((state: any) => state.company);
  const { company, company_select }: any = useSelector((state: any) => state.company);

  const { sucursales_list_select }: any = useSelector((state: any) => state.sucursales);

  const { cargos_list, cargos_select } = useSelector((state: any) => state.cargos);
  const { type_documents_list, type_documents_list_select } = useSelector(
    (state: any) => state.tipodocumento
  );

  const { departaments_list }: any = useSelector((state: any) => state.departaments);
  const { municipaly_list }: any = useSelector((state: any) => state.municipalies);

  const [typeDocument, setTypeDocument] = useState([]);

  const [countries, setCountries] = useState([]);
  const [departaments, setDepartaments] = useState([]);
  const [municipalies, setMunicipalies] = useState([]);
  const [cargos, setCargos] = useState([]);

  const [percentage_upload_cc, setPercentageUploadCc] = useState(0);

  const [percentage_upload_cv, setPercentageUploadCv] = useState(0);

  const [withPhoto, setWithPhoto] = useState(true);
  const [withImagen, setWithImagen] = useState(false);

  const [textAlertSnack, setTextAlertSnack] = useState('');
  const [severity, setSeverity] = useState('success');

  const [showCamera, setShowCamera] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);

  const [imgSrcUpload, setImgSrcUpload] = useState<any>(null);

  // VISITA DOMICILIARIA
  const [percentage_upload_img, setPercentageUploadImg] = useState(0);

  // COMPAÑIA
  const [company_formated, setCompanyFormated] = useState([]);

  // ALERTS PARA CONFIGURACION SUBIR IMAGEN
  const [alert_snack, setAlertSnack] = useState(false);
  const [alert_snack_company, setAlertSnackCompany] = useState(false);
  const [alert_snack_cargos, setAlertSnackCargos] = useState(false);

  const [percentage_upload_cedula, setPercentageUploadRut] = useState(0);

  // **************************************************************************
  // **************************************************************************
  //          // MANEJO IAMGEN CROP PHOTO
  // **************************************************************************
  // **************************************************************************
  const [cropPhoto, setCropPhoto] = useState({ x: 0, y: 0 });
  const [zoomPhoto, setZoomPhoto] = useState(1);
  const [rotationPhoto, setRotationPhoto] = useState(0);
  // Estado nuevo para imagen recortada
  const [croppedImgPhoto, setCroppedImgPhoto] = useState<string | null>(null);

  const onCropCompletePhoto = useCallback((_: Area, croppedAreaPixelsPhoto: Area) => {
    setCroppedAreaPixelsPhoto(croppedAreaPixelsPhoto);
  }, []);

  const [croppedAreaPixelsPhoto, setCroppedAreaPixelsPhoto] = useState<Area>({
    x: 0,
    y: 0,
    width: 320,
    height: 240,
  });

  const handleSavePhoto = () => {
    const imageSrc = formikProps.values.picture_photo_taked;

    // Verificación más específica
    if (!croppedAreaPixelsPhoto || !imageSrc) {
      console.log('No se puede guardar - faltan datos:', {
        tieneCroppedArea: !!croppedAreaPixelsPhoto,
        tieneImagen: !!imageSrc,
        imagen: imageSrc,
      });
      return;
    }

    // Verifica que croppedAreaPixelsPhoto tenga dimensiones válidas
    if (croppedAreaPixelsPhoto.width <= 0 || croppedAreaPixelsPhoto.height <= 0) {
      console.log('Dimensiones de recorte inválidas:', croppedAreaPixelsPhoto);
      return;
    }

    console.log('Procesando imagen...');

    const image = new Image();
    image.src = imageSrc;

    image.onload = () => {
      console.log('Imagen cargada, dimensiones:', image.width, 'x', image.height);

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.log('Error: No se pudo obtener el contexto 2D');
        return;
      }

      canvas.width = croppedAreaPixelsPhoto.width;
      canvas.height = croppedAreaPixelsPhoto.height;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotationPhoto * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        image,
        croppedAreaPixelsPhoto.x,
        croppedAreaPixelsPhoto.y,
        croppedAreaPixelsPhoto.width,
        croppedAreaPixelsPhoto.height,
        0,
        0,
        croppedAreaPixelsPhoto.width,
        croppedAreaPixelsPhoto.height
      );

      canvas.toBlob((blob) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          console.log('Recorte guardado exitosamente:', url);

          // setCroppedImgPhoto(url);
          formikProps.setFieldValue('foto_name_saved', url);

          formikProps.setFieldValue('setCroppedImgPhoto', url);

          formikProps.setFieldValue('imagenEmployeeToSave', blob);
        } else {
          console.log('Error: No se pudo crear el blob del recorte');
        }
      }, 'image/jpeg');
    };

    image.onerror = () => {
      console.log('Error al cargar la imagen');
    };
  };

  //***************************************************************************
  // **************************************************************************
  //          FIN MANEJO IAMGEN CROP PHOTO FIN
  // **************************************************************************
  // **************************************************************************

  // **************************************************************************
  // **************************************************************************
  //          // MANEJO IAMGEN CROP UPLOAD
  // **************************************************************************
  // **************************************************************************
  const [cropUpload, setCropUpload] = useState({ x: 0, y: 0 });
  const [zoomUpload, setZoomUpload] = useState(1);
  const [rotationUpload, setRotationUpload] = useState(0);
  // Estado nuevo para imagen recortada
  const [croppedImgUpload, setCroppedImgUpload] = useState<string | null>(null);

  const onCropCompleteUpload = useCallback((_: Area, croppedAreaPixelsUpload: Area) => {
    setCroppedAreaPixelsUpload(croppedAreaPixelsUpload);
  }, []);

  const [croppedAreaPixelsUpload, setCroppedAreaPixelsUpload] = useState<Area>({
    x: 0,
    y: 0,
    width: 320,
    height: 240,
  });

  const handleSaveUpload = () => {
    console.log('Intentando guardar recorte...');

    const imageSrc = formikProps.values.picture_upload_taked;

    // Verificación más específica
    if (!croppedAreaPixelsUpload || !imageSrc) {
      console.log('No se puede guardar - faltan datos:', {
        tieneCroppedArea: !!croppedAreaPixelsUpload,
        tieneImagen: !!imageSrc,
        imagen: imageSrc,
      });
      return;
    }

    // Verifica que croppedAreaPixelsUpload tenga dimensiones válidas
    if (croppedAreaPixelsUpload.width <= 0 || croppedAreaPixelsUpload.height <= 0) {
      console.log('Dimensiones de recorte inválidas:', croppedAreaPixelsUpload);
      return;
    }

    console.log('Procesando imagen...');

    const image = new Image();
    image.src = imageSrc;

    image.onload = () => {
      console.log('Imagen cargada, dimensiones:', image.width, 'x', image.height);

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.log('Error: No se pudo obtener el contexto 2D');
        return;
      }

      canvas.width = croppedAreaPixelsUpload.width;
      canvas.height = croppedAreaPixelsUpload.height;

      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotationUpload * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        image,
        croppedAreaPixelsUpload.x,
        croppedAreaPixelsUpload.y,
        croppedAreaPixelsUpload.width,
        croppedAreaPixelsUpload.height,
        0,
        0,
        croppedAreaPixelsUpload.width,
        croppedAreaPixelsUpload.height
      );

      canvas.toBlob((blob) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          console.log('Recorte guardado exitosamente:', url);

          setCroppedImgUpload(url);
          // setCroppedImgPhoto(url);
          formikProps.setFieldValue('upload_name_saved', url);

          formikProps.setFieldValue('set_zoom_upload', 1);
          formikProps.setFieldValue('set_rotation_upload', 0);

          formikProps.setFieldValue('setCroppedImgUpload', url);
          formikProps.setFieldValue('show_controls_upload', false);

          formikProps.setFieldValue('imagenEmployeeToSaveUpload', blob);
        } else {
          console.log('Error: No se pudo crear el blob del recorte');
        }
      }, 'image/jpeg');
    };

    image.onerror = () => {
      console.log('Error al cargar la imagen');
    };
  };

  //***************************************************************************
  // **************************************************************************
  //          FIN MANEJO IAMGEN CROP UPLOAD FIN
  // **************************************************************************
  // **************************************************************************

  const {
    formField: {
      // DATOS CLIENTE
      document_type,
      expedition_place,
      file_img_upload,
      name,
      document_number,
      last_name,
      date_of_birth,
      gender,
      civil_status,
      landline,
      cell_phone,
      corporate_cell_phone,
      whatsapp,
      rh,
      dominance,
      allergies,
      cedula,
      housing_type,
      neighborhood,
      stratum,
      cost_center,
      compani,
      work_headquarters,
      cargo,
      cv,
      scholarship,
      institution,
      degree,
      address,
      email,
    },
  } = props;

  useEffect(() => {
    console.log(' company_select mmm ', company_select);
    // if ( Object.keys(company).length > 0 && company.constructor === Object ) {

    //  const dataCompany:any = [{
    //      label: company.tradename,
    //      value: company.id

    // }];

    setCompanyFormated(company_select);

    //  const dataCompanyDefault = {
    //     label: company.tradename,
    //     value: company.id
    //  }

    formikProps.setFieldValue('compani', company_select);

    // }
  }, [company]);

  useEffect(() => {
    getDataInputesForm();
  }, []);

  useEffect(() => {
    setDepartaments(departaments_list);
  }, [departaments_list]);

  useEffect(() => {
    setMunicipalies(municipaly_list);
  }, [municipaly_list]);

  //  CARGOS
  useEffect(() => {
    if (cargos_list.length > 0) {
      const cargosList = cargos_list.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
        };
      });

      setCargos(cargosList);
    }
  }, [cargos_list]);

  const getDataInputesForm = async () => {
    // console.log('sddddd')
    // const response = await dispatch( getFormsDataS() );
    // setCountries([]);
    // setDepartaments([]);
    // setMunicipalies([]);
  };

  const genderList = [
    { label: 'Masculino', value: 'masculino' },
    { label: 'Femenino', value: 'Femenino' },
    { label: 'Otro', value: 'otro' },
  ];

  const maritalStatus = [
    { label: 'Soltero', value: 'soltero' },
    { label: 'Casado', value: 'casado' },
    { label: 'Union Libre', value: 'unionlibre' },
    { label: 'Viudo', value: 'viudo' },
    { label: 'Separado', value: 'separado' },
  ];

  const bloodType = [
    { label: 'AB+', value: 'AB+' },
    { label: 'AB-', value: 'AB-' },
    { label: 'A+', value: 'A+' },
    { label: 'A-', value: 'A-' },
    { label: 'B+', value: 'B+' },
    { label: 'B-', value: 'B-' },
    { label: 'O+', value: 'O+' },
    { label: 'O-', value: 'O-' },
  ];

  const domiNacion = [
    { label: 'zurdo', value: 'zurdo' },
    { label: 'diestro', value: 'diestro' },
    { label: 'ambidiestro', value: 'ambidiestro' },
  ];

  const typeOfHousing = [
    { label: 'propia', value: 'propia' },
    { label: 'alquiler', value: 'alquiler' },
    { label: 'familiar', value: 'familiar' },
    { label: 'ninguno', value: 'ninguno' },
  ];

  const costCenter = [
    { label: 'administrativo', value: 'administrativo' },
    { label: 'mano de obra directa', value: 'mano_de_obra_directa' },
    { label: 'mano de obra indirecta', value: 'mano_de_obra_indirecta' },
    { label: 'operativo', value: 'operativo' },
    { label: 'ventas', value: 'ventas' },
  ];

  const escolaridadList = [
    { label: 'primaria', value: 'primaria' },
    { label: 'bachillerato', value: 'bachillerato' },
    { label: 'tecnico', value: 'tecnico' },
    { label: 'tecnologo', value: 'tecnologo' },
    { label: 'pregrado', value: 'pregrado' },
    { label: 'postgrado', value: 'postgrado' },
  ];

  const uploadCedula = async ({ target }: any) => {
    formikProps.setFieldValue('cedula', target.files[0]);
    const response = await dispatch(
      uploadPdfStore('cedula-empleado', target.files[0], setPercentageUploadCc)
    );

    if (response.ok) {
      formikProps.setFieldValue('cedula_name_saved_name', response.data.pdfName);
    }
  };

  const uploadCV = async ({ target }: any) => {
    formikProps.setFieldValue('cv', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('cv-empleado', target.files[0], setPercentageUploadCv)
    );

    if (ok) {
      formikProps.setFieldValue('cv_name_saved_name', data.pdfName);
    }
  };

  const uploadImagenCamera = async (imgSrc: any) => {
    // Convertir la imagen a un archivo Blob
    const blob = await fetch(imgSrc).then((res) => res.blob());

    formikProps.setFieldValue('imagenEmployeeToSave', blob);
    formikProps.setFieldValue('foto_name_saved', 'employee.png');
    formikProps.setFieldValue('picture_photo_taked', URL.createObjectURL(blob));
    // const response = await dispatch( uploadFileImageFromCamera( 'avatar-employee', blob, setPercentageUploadCc) );

    // if (!response.ok) {

    //   setImgSrc(null);
    //   formikProps.setFieldValue('foto_name_saved', null);
    //   setSeverity('error')
    //   setTextAlertSnack(response.errors[0]);
    //   setAlertSnack(true);
    //   return false;
    // }

    // if (response.ok) {
    //   formikProps.setFieldValue('foto_name_saved', response.data.imgName);
    //   formikProps.setFieldValue('picture_photo_taked',URL.createObjectURL(blob) );

    // }
  };

  const openCamera = () => {
    setShowCamera(!showCamera);
    setImgSrc(null);
    formikProps.values.picture_photo_taked = null;

    // formikProps.values.setCroppedImgPhoto = null;
    formikProps.setFieldValue('setCroppedImgPhoto', null);
  };

  const newPhoto = () => {
    setShowCamera(false);
  };

  const webcamRef: any = useRef(null);

  const capture = useCallback(async () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (!imageSrc) return;
    setImgSrc(imageSrc);
    setShowCamera(false);
    await uploadImagenCamera(imageSrc);

    formikProps.setFieldValue('set_zoom_photo', 1);
    formikProps.setFieldValue('set_rotation_photo', 0);
  }, [webcamRef]);

  const videoConstraints = {
    width: 320,
    height: 240,
    facingMode: 'user',
  };

  useEffect(() => {
    company_select.length <= 0 ? setAlertSnackCompany(true) : setAlertSnackCompany(false);
  }, [company_select]);

  useEffect(() => {
    cargos_select.length <= 0 ? setAlertSnackCargos(true) : setAlertSnackCargos(false);
  }, [cargos_select]);

  useEffect(() => {
    if (formikProps.values.with_photo) {
      setWithPhoto(true);
      setWithImagen(false);
    }
  }, []);

  useEffect(() => {
    if (formikProps.values.with_imagen) {
      setWithPhoto(false);
      setWithImagen(true);
    }
  }, []);

  useEffect(() => {
    if (!formikProps.values.with_photo && !formikProps.values.with_imagen) {
      formikProps.setFieldValue('with_photo', true);
    }
  }, []);

  const isWithPhoto = (checked: boolean) => {
    setWithPhoto(checked);
    setWithImagen(!checked);

    formikProps.setFieldValue('with_photo', checked);
    formikProps.setFieldValue('with_imagen', !checked);
  };
  const isWithImagen = (checked: boolean) => {
    setWithImagen(checked);
    setWithPhoto(!checked);

    formikProps.setFieldValue('with_imagen', checked);
    formikProps.setFieldValue('with_photo', !checked);
  };

  const uploadImg = async ({ target }: any) => {
    if (!target.files || target.files.length === 0) return;
    const file = target.files[0];
    formikProps.setFieldValue('setCroppedImgUpload', null);

    formikProps.setFieldValue('imagenEmployeeToSaveUpload', file);
    formikProps.setFieldValue('file_img_upload', file);
    formikProps.setFieldValue('picture_upload_taked', URL.createObjectURL(file));
    formikProps.setFieldValue('show_controls_upload', true);

    setTimeout(() => {
      formikProps.setFieldValue('set_zoom_upload', 1);
    }, 700);
  };

  // useEffect(() => {
  //   if (formikProps.values.picture_upload_taked) {
  //     formikProps.setFieldValue('set_zoom_upload', 1);
  //   }
  // }, [formikProps.values.picture_upload_taked]);

  useEffect(() => {
    if (formikProps.values.img_uploaded_saved instanceof File) {
      setImgSrcUpload(URL.createObjectURL(formikProps.values.img_uploaded_saved));
    }
  }, []);

  const handleBlurEmail = async (e: any) => {
    // call formik's onBlur to update touched status
    formikProps.handleBlur(e);

    const emailValue = e.target.value;
    if (emailValue && !formikProps.errors[email.name]) {
      const response = await dispatch(storeVerifyEmail(emailValue));
      if (response && response.ok && response.data?.existe && response.data?.id) {
        formikProps.setFieldValue('existingEmployeeId', response.data.id);
      } else {
        formikProps.setFieldValue('existingEmployeeId', null);
      }
    } else {
      formikProps.setFieldValue('existingEmployeeId', null);
    }
  };

  const goToEmployee = async (id: string) => {
    await dispatch(storeDetailEmployee(id));
    navigate('/talento-humano/empleados/detalle');
  };

  return (
    <div>
      <SnackAlert
        open={alert_snack_cargos}
        autohidden={false}
        onclick={setAlertSnackCargos}
        text={'Aun no has creado los cargos'}
        severity={'warning'}
      />

      <SnackAlert
        open={alert_snack_company}
        autohidden={false}
        onclick={setAlertSnackCompany}
        text={'Aun no has creado la compañia'}
        severity={'warning'}
      />

      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={textAlertSnack}
        severity={severity}
      />

      {/* <SnackbarProvider maxSnack={3}>
          <SnackGroupAlerts message={'aaaaaaa'} variant={'warning'}/>
        </SnackbarProvider> */}

      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} sx={{ marginTop: 3 }}>
          <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f9f9f9' }}>
            <FormGroup row sx={{ justifyContent: 'space-between' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={withPhoto}
                    onChange={(_, checked) => {
                      isWithPhoto(checked);
                    }}
                    color="primary"
                  />
                }
                label="Con Foto"
                sx={{ marginRight: 2 }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={withImagen}
                    onChange={(_, checked) => {
                      isWithImagen(checked);
                    }}
                    color="primary"
                  />
                }
                label="Subir Imagen"
              />
            </FormGroup>
          </Paper>
        </Grid>

        {withPhoto && (
          <Grid size={{ xs: 12 }} sx={{ my: 3 }}>
            <Paper
              elevation={4}
              sx={{ p: 3, borderRadius: 3, backgroundColor: '#f5f7fa', textAlign: 'center' }}
            >
              {formikProps.values.picture_photo_taked && (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                  {/* Título centrado */}
                  <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center' }}>
                    Vista previa de la foto:
                  </Typography>

                  {/* Área del cropper centrada photo */}
                  <Box
                    sx={{
                      position: 'relative',
                      width: 320,
                      height: 240,
                      borderRadius: 2,
                      overflow: 'hidden', // evita que el cropper se salga
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {formikProps.values.picture_photo_taked && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          mb: 2,
                        }}
                      >
                        <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center' }}>
                          {formikProps.values.setCroppedImgPhoto
                            ? 'Vista previa del recorte guardado:'
                            : 'Ajusta la foto:'}
                        </Typography>

                        <Box
                          sx={{
                            position: 'relative',
                            width: 320,
                            height: 240,
                            background: '#333',
                            borderRadius: 2,
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {/* Mostrar Cropper si NO hay imagen recortada */}
                          {!formikProps.values.setCroppedImgPhoto &&
                            formikProps.values.picture_photo_taked && (
                              <Cropper
                                image={formikProps.values.picture_photo_taked}
                                crop={cropPhoto} // este sí puede seguir en useState
                                zoom={formikProps.values.set_zoom_photo || 1}
                                rotation={formikProps.values.set_rotation_photo || 0}
                                aspect={4 / 3}
                                objectFit="cover"
                                onCropChange={setCropPhoto}
                                onZoomChange={(z) => formikProps.setFieldValue('set_zoom_photo', z)}
                                onRotationChange={(r) =>
                                  formikProps.setFieldValue('set_rotation_photo', r)
                                }
                                onCropComplete={onCropCompletePhoto}
                                style={{
                                  containerStyle: {
                                    background: '#fff', // cambia el fondo del contenedor
                                  },
                                  mediaStyle: {
                                    background: '#fff', // evita el fondo negro al rotar
                                  },
                                }}
                              />
                            )}

                          {/* Mostrar imagen recortada si EXISTE */}
                          {formikProps.values.picture_photo_taked && (
                            <img
                              src={formikProps.values.setCroppedImgPhoto}
                              alt="Recorte guardado"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: 8,
                              }}
                            />
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              )}

              {/* 🔹 Controles photo */}
              {imgSrc && !formikProps.values.setCroppedImgPhoto && (
                <Box
                  sx={{
                    mt: 2,
                    width: '100%', // el contenedor ocupa todo
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', // centra todo horizontalmente
                  }}
                >
                  <Box sx={{ width: '60%', maxWidth: 300 }}>
                    <Typography gutterBottom align="center">
                      Zoom
                    </Typography>
                    <Slider
                      value={formikProps.values.set_zoom_photo || 1}
                      min={1}
                      max={3}
                      step={0.1}
                      onChange={(_, v) => formikProps.setFieldValue('set_zoom_photo', v)}
                    />

                    {/* <Typography gutterBottom align="center">Rotación</Typography>
                      <Slider
                        disabled
                        value={formikProps.values.set_rotation_photo || 0}
                        min={0}
                        max={360}
                        step={1}
                        onChange={(_, v) => formikProps.setFieldValue('set_rotation_photo', v)}
                      /> */}
                  </Box>

                  {imgSrc && !croppedImgPhoto && (
                    <Button
                      variant="contained"
                      color={'success'}
                      onClick={handleSavePhoto}
                      sx={{ mt: 2 }}
                    >
                      Guardar recorte
                    </Button>
                  )}
                </Box>
              )}

              {/* Botón para volver a editar si ya hay recorte */}
              {croppedImgPhoto && (
                <Button
                  variant="contained"
                  color={'warning'}
                  onClick={() => setCroppedImgPhoto(null)}
                  sx={{ mt: 2 }}
                >
                  Volver a editar
                </Button>
              )}

              {showCamera && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Cámara activa:
                  </Typography>
                  <Webcam
                    audio={false}
                    height={240}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    width={320}
                    videoConstraints={videoConstraints}
                    style={{ borderRadius: 8, border: '2px solid #ccc' }}
                  />
                </Box>
              )}

              <Box
                sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2, mt: 2 }}
              >
                {imgSrc && (
                  <Button variant="contained" onClick={openCamera} color="primary">
                    Tomar nueva foto
                  </Button>
                )}

                {!showCamera && !imgSrc && (
                  <Button variant="contained" onClick={openCamera} color="primary">
                    Encender cámara
                  </Button>
                )}

                {showCamera && (
                  <Button variant="contained" onClick={capture} color="success">
                    Tomar foto
                  </Button>
                )}
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>

      {withImagen && (
        <Grid size={{ xs: 12 }} sx={{ my: 3 }}>
          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            sx={{
              width: '100%',
            }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor: '#f9f9f9',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {withImagen && formikProps.values.picture_upload_taked && (
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      width: '100%',
                    }}
                  >
                    Vista previa de la foto:
                  </Typography>

                  {/* Área del cropper centrada photo */}
                  <Box
                    sx={{
                      position: 'relative',
                      width: 320,
                      height: 240,
                      borderRadius: 2,
                      overflow: 'hidden', // evita que el cropper se salga
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {formikProps.values.picture_upload_taked && (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          mb: 2,
                        }}
                      >
                        <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center' }}>
                          {croppedImgUpload
                            ? 'Vista previa del recorte guardado:'
                            : 'Ajusta la foto:'}
                        </Typography>

                        <Box
                          sx={{
                            position: 'relative',
                            width: 320,
                            height: 240,
                            background: '#333',
                            borderRadius: 2,
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {/* Mostrar Cropper si NO hay imagen recortada */}
                          {!formikProps.values.setCroppedImgUpload &&
                            formikProps.values.picture_upload_taked && (
                              <Cropper
                                image={formikProps.values.picture_upload_taked}
                                crop={cropUpload} // este sí puede seguir en useState
                                zoom={formikProps.values.set_zoom_upload}
                                rotation={formikProps.values.set_rotation_upload}
                                aspect={4 / 3}
                                objectFit="cover"
                                onCropChange={setCropUpload}
                                onZoomChange={(z) =>
                                  formikProps.setFieldValue('set_zoom_upload', z)
                                }
                                onRotationChange={(r) =>
                                  formikProps.setFieldValue('set_rotation_upload', r)
                                }
                                onCropComplete={onCropCompleteUpload}
                              />
                            )}

                          {/* Mostrar imagen recortada si EXISTE */}
                          {formikProps.values.picture_upload_taked && (
                            <img
                              src={formikProps.values.setCroppedImgUpload}
                              alt="Recorte guardado"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: 8,
                              }}
                            />
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>

                  {/* croppedImgUpload */}
                  {/* 🔹 Controles upload */}
                  {formikProps.values.show_controls_upload && (
                    <Box
                      sx={{
                        mt: 2,
                        width: '100%', // el contenedor ocupa todo
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center', // centra todo horizontalmente
                      }}
                    >
                      <Box sx={{ width: '70%', maxWidth: 300 }}>
                        <Typography gutterBottom align="center">
                          Zoom{' '}
                        </Typography>
                        <Slider
                          value={formikProps.values.set_zoom_upload || 1}
                          min={1}
                          max={3}
                          step={0.1}
                          onChange={(_, v) => formikProps.setFieldValue('set_zoom_upload', v)}
                        />

                        {/* <Typography gutterBottom align="center">Rotación</Typography>
                              <Slider
                                
                                value={formikProps.values.set_rotation_upload || 0}
                                min={0}
                                max={360}
                                step={1}
                                onChange={(_, v) => formikProps.setFieldValue('set_rotation_upload', v)}
                              /> */}
                      </Box>

                      {!formikProps.values.setCroppedImgUpload && (
                        <Button
                          variant="contained"
                          color={'success'}
                          onClick={handleSaveUpload}
                          sx={{ mt: 2 }}
                        >
                          Guardar recorte
                        </Button>
                      )}
                    </Box>
                  )}
                </Box>
              )}

              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                Subir Imagen
              </Typography>

              <UploadButtonField
                accept={'image/*'}
                name={file_img_upload.name}
                label={file_img_upload.label}
                text={'Seleccionar archivo'}
                onChange={uploadImg}
                style={{ marginTop: 10 }}
              />
            </Paper>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          {type_documents_list_select && Object.keys(type_documents_list_select).length > 0 ? (
            <AutocompleteField
              options={type_documents_list_select}
              name={document_type.name}
              label={document_type.label}
              required={true}
              element={document_type.name}
            />
          ) : (
            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear los tipos de documentos*'}
              required={true}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputNumeric
            name={document_number.name}
            label={document_number.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={expedition_place.name}
            label={expedition_place.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 3 }}>
          <InputField
            name={name.name}
            label={name.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={last_name.name}
            label={last_name.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <DatePickerField label={date_of_birth.label} required={true} name={date_of_birth.name} />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={genderList}
            name={gender.name}
            label={gender.label}
            required={true}
            element={gender.name}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={maritalStatus}
            name={civil_status.name}
            label={civil_status.label}
            required={true}
            element={civil_status.name}
          />
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={landline.name}
            label={landline.label}
            required={false}
            variant="outlined"
            fullWidth
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const formatted = formatShortPhoneNumber(e.target.value);
              // Actualiza el valor en formik usando setFieldValue
              formikProps.setFieldValue(landline.name, formatted);
            }}
            value={formikProps.values[landline.name] || ''}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={cell_phone.name}
            label={cell_phone.label}
            required={true}
            variant="outlined"
            fullWidth
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const formatted = formatPhoneNumber(e.target.value);
              // Actualiza el valor en formik usando setFieldValue
              formikProps.setFieldValue(cell_phone.name, formatted);
            }}
            value={formikProps.values[cell_phone.name] || ''}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={corporate_cell_phone.name}
            label={corporate_cell_phone.label}
            required={false}
            variant="outlined"
            fullWidth
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const formatted = formatPhoneNumber(e.target.value);
              formikProps.setFieldValue(corporate_cell_phone.name, formatted);
            }}
            value={formikProps.values[corporate_cell_phone.name] || ''}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
            <CheckboxField name={whatsapp.name} label={whatsapp.label} required={true} />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 4 }}>
          <InputField
            name={email.name}
            label={email.label}
            required={true}
            variant="outlined"
            fullWidth
            onBlur={handleBlurEmail}
          />
        </Grid>
      </Grid>
      {/* END GRID  */}

      {formikProps.values.existingEmployeeId && (
        <Box sx={{ mt: 3, mb: 1, width: '100%' }}>
          <Paper
            elevation={2}
            sx={{
              p: 2.5,
              borderRadius: 2,
              background: 'linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%)',
              border: '1px solid #ffda6a',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 2,
              boxShadow: '0 4px 12px rgba(255, 193, 7, 0.2)',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  bgcolor: '#ffc107',
                  borderRadius: '50%',
                  width: 48,
                  height: 48,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#000',
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                }}
              >
                !
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 800, color: '#664d03', lineHeight: 1.2 }}
                >
                  ¡ATENCIÓN!
                </Typography>
                <Typography variant="body1" sx={{ color: '#664d03', fontWeight: 500, mt: 0.5 }}>
                  Este correo electrónico ya se encuentra registrado para otro empleado en el
                  sistema.
                </Typography>
              </Box>
            </Box>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                fontWeight: 800,
                fontSize: '1rem',
                py: 1.5,
                px: 4,
                borderRadius: 2,
                textTransform: 'uppercase',
                boxShadow: '0 4px 14px 0 rgba(25, 118, 210, 0.39)',
                flexShrink: 0,
              }}
              onClick={() => goToEmployee(formikProps.values.existingEmployeeId)}
            >
              Ver Empleado Registrado
            </Button>
          </Paper>
        </Box>
      )}

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={bloodType}
            name={rh.name}
            label={rh.label}
            required={true}
            element={rh.name}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={domiNacion}
            name={dominance.name}
            label={dominance.label}
            required={true}
            element={dominance.name}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <TextAreaField
            name={allergies.name}
            label={allergies.label}
            required={true}
            placeholder="Ej. Ninguna, polen, etc."
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <UploadButtonField
            accept={'application/pdf'}
            name={cedula.name}
            label={cedula.label}
            text={'Cedula'}
            required={
              !(
                formikProps.values.cedula ||
                (formikProps.values.e_cedula_name_saved_name &&
                  !formikProps.values.e_cedula_name_saved_name.includes('dummy')) ||
                (formikProps.values.cedula_name_saved_name &&
                  !formikProps.values.cedula_name_saved_name.includes('dummy'))
              )
            }
            onChange={uploadCedula}
            style={{ marginTop: 10, width: '100%' }}
          />
          {formikProps.values.cedula ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={formikProps.values.cedula_name_saved_name ? 100 : percentage_upload_cc}
                label={formikProps.values.cedula.name}
                hasIcon={true}
              />
              {formikProps.values.cedula_name_saved_name &&
                props.onOpenPdf &&
                !formikProps.values.cedula_name_saved_name.includes('dummy') && (
                  <PreviewPdfButton
                    fileName={formikProps.values.cedula_name_saved_name}
                    typeUrl="cedula-empleado"
                    onOpenPdf={props.onOpenPdf}
                    label="Previsualizar Cédula"
                  />
                )}
            </Card>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 10 }}>
        Datos Domiciliarios
      </Typography>

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={address.name}
            label={address.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>

        <Grid size={{ xs: 3 }}>
          <InputField
            name={neighborhood.name}
            label={neighborhood.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={typeOfHousing}
            name={housing_type.name}
            label={housing_type.label}
            required={true}
            element={housing_type.name}
          />
        </Grid>
        <Grid size={{ xs: 2 }}>
          <InputNumeric
            name={stratum.name}
            label={stratum.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 10 }}>
        Laboral
      </Typography>

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 2 }}>
          <AutocompleteField
            options={costCenter}
            name={cost_center.name}
            label={cost_center.label}
            element={cost_center.name}
            required={true}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          {company_select && Object.keys(company_select).length > 0 ? (
            <AutocompleteField
              options={company_select}
              name={compani.name}
              label={compani.label}
              required={true}
              element={compani.name}
            />
          ) : (
            // <TextField
            //   fullWidth
            //   name={company.tradename}
            //   label={compani.label}
            //   defaultValue={company.tradename}
            //   InputProps={{
            //     readOnly: true,
            //   }}
            // />

            <InputField
              disabled
              error
              name={'N/A'}
              label={'Debes crear la compañia*'}
              required={true}
              variant="outlined"
              fullWidth
            />
          )}
        </Grid>

        <Grid size={{ xs: 2 }}>
          <AutocompleteField
            options={sucursales_list_select}
            name={work_headquarters.name}
            label={work_headquarters.label}
            required={true}
            element={work_headquarters.name}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          {cargos_select && Object.keys(cargos_select).length > 0 ? (
            <AutocompleteField
              options={cargos_select}
              name={cargo.name}
              label={cargo.label}
              required={true}
              element={cargo.name}
            />
          ) : (
            ''
          )}
        </Grid>
        <Grid size={{ xs: 3 }}>
          <UploadButtonField
            accept={'application/pdf'}
            name={cv.name}
            label={cv.label}
            text={'Hoja de Vida'}
            required={
              !(
                formikProps.values.cv ||
                (formikProps.values.e_cv_name_saved_name &&
                  !formikProps.values.e_cv_name_saved_name.includes('dummy')) ||
                (formikProps.values.cv_name_saved_name &&
                  !formikProps.values.cv_name_saved_name.includes('dummy'))
              )
            }
            onChange={uploadCV}
            style={{ marginTop: 10, width: '100%' }}
          />
          {formikProps.values.cv ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1, height: '70%' }}>
              <LinearProgressWithLabel
                percentage={formikProps.values.cv_name_saved_name ? 100 : percentage_upload_cv}
                label={formikProps.values.cv.name}
                hasIcon={true}
              />
              {formikProps.values.cv_name_saved_name &&
                props.onOpenPdf &&
                !formikProps.values.cv_name_saved_name.includes('dummy') && (
                  <PreviewPdfButton
                    fileName={formikProps.values.cv_name_saved_name}
                    typeUrl="cv-empleado"
                    onOpenPdf={props.onOpenPdf}
                    label="Previsualizar Hoja de Vida"
                  />
                )}
            </Card>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider style={{ marginTop: 25 }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginTop: 10 }}>
        Academico
      </Typography>

      <Grid container spacing={2} style={{ marginTop: 15 }}>
        <Grid size={{ xs: 3 }}>
          <AutocompleteField
            options={escolaridadList}
            name={scholarship.name}
            label={scholarship.label}
            required={true}
            element={scholarship.name}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={institution.name}
            label={institution.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <InputField
            name={degree.name}
            label={degree.label}
            required={true}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>

      {/* END GRID  */}
    </div>
  );
};
